import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AuthQueryOptions, BOOKMARK_TYPE } from '@/api';
import { NewsCard } from '@/components/molecule/NewsCard';
import { ROUTES } from '@/constants';
import { useBookmark } from '@/hooks/useBookmark';
import { buildDetailSlug } from '@/utils/detailSlug';
import { EmptyScrapList } from './EmptyScrapList';
export const PolicyInfoScrapList = () => {
  const $ = _c(12);
  const {
    bookmark
  } = useBookmark();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...AuthQueryOptions["get:/wello/v2/auth/member/wishlist/best-contents"](),
      select: _temp,
      placeholderData: keepPreviousData
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: policyInfoScrap
  } = useQuery(t0);
  if (!policyInfoScrap?.totalCount) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <EmptyScrapList />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== policyInfoScrap.totalCount) {
    t1 = <p className="px-20 py-10 font-500 text-Gray-black typo-body4">총 {policyInfoScrap.totalCount}개</p>;
    $[2] = policyInfoScrap.totalCount;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== bookmark || $[5] !== policyInfoScrap.contents) {
    t2 = policyInfoScrap?.contents?.map(policyInfo => <li key={policyInfo.bestContentsId}><NewsCard id={policyInfo.bestContentsId} daysAgo={policyInfo.daysAgo} imageSrc={policyInfo.fileUrl} isBookmarked={policyInfo.wishlistYN} link={ROUTES.POLICY_INFO_DETAIL.pathname({
        idIdx: buildDetailSlug(policyInfo.bestContentsIdIdx, policyInfo.title)
      })} title={policyInfo.title} onClickBookmark={() => {
        bookmark({
          bookmarkType: BOOKMARK_TYPE.POLICY_INFO,
          contentId: policyInfo.bestContentsId,
          isBookmarked: policyInfo.wishlistYN,
          idx: policyInfo.bestContentsIdIdx,
          contentName: policyInfo.title
        });
      }} /></li>);
    $[4] = bookmark;
    $[5] = policyInfoScrap.contents;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <ul className="flex flex-col gap-16">{t2}</ul>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t3) {
    t4 = <article className="flex flex-col">{t1}{t3}</article>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}